import React, { useState } from "react";
import "./PricingPage.css";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { FaSave, FaTimes } from "react-icons/fa";
import { toast } from "react-toastify";

import { savePricing } from "../../../services/payment/api";
import { approveClient } from "../../../services/admin/api";

const defaultPricing = [
  {
    checkId: 1,
    checkName: "Digilocker Check",
    price: "",
  },
  {
    checkId: 2,
    checkName: "Criminal Check",
    price: "",
  },
  {
    checkId: 3,
    checkName: "UAN Check",
    price: "",
  },
  {
    checkId: 4,
    checkName: "Employment Check",
    price: "",
  },
];

const PostClientPricing = () => {
  const { clientId } = useParams();
  const navigate = useNavigate();
  const location = useLocation();

  const client = location.state?.client;

  const [pricingItems, setPricingItems] = useState(defaultPricing);
  const [errors, setErrors] = useState({});
  const [saving, setSaving] = useState(false);

  const handlePrice = (index, value) => {
    const updated = [...pricingItems];
    updated[index].price = value;

    setPricingItems(updated);

    setErrors((prev) => {
      const temp = { ...prev };
      delete temp[updated[index].checkId];
      return temp;
    });
  };

  const validatePricing = () => {
    const validationErrors = {};

    pricingItems.forEach((item) => {
      const price = Number(item.price);

      if (item.price === "" || item.price === null) {
        validationErrors[item.checkId] = "Price is required";
        return;
      }

      switch (item.checkId) {
        case 1:
          if (price < 50)
            validationErrors[item.checkId] =
              "Minimum price for Digilocker Check is ₹50";
          break;

        case 2:
          if (price < 100)
            validationErrors[item.checkId] =
              "Minimum price for Criminal Check is ₹100";
          break;

        case 3:
          if (price < 200)
            validationErrors[item.checkId] =
              "Minimum price for UAN Check is ₹200";
          break;

        case 4:
          if (price < 200)
            validationErrors[item.checkId] =
              "Minimum price for Employment Check is ₹200";
          break;

        default:
          break;
      }
    });

    setErrors(validationErrors);

    return Object.keys(validationErrors).length === 0;
  };

  const handleSaveAndApprove = async () => {
    if (!validatePricing()) return;

    const request = {
      pricingItems: pricingItems.map((item) => ({
        checkId: item.checkId,
        price: Number(item.price),
      })),
    };

    try {
      setSaving(true);

      // Save pricing
      await savePricing(clientId, request);

      // Approve client
      await approveClient(clientId);

      toast.success("Pricing saved and client approved successfully.");

      navigate("/admin/clients/pending");
    } catch (error) {
      toast.error(
        error.response?.data?.message || "Failed to save pricing."
      );
    } finally {
      setSaving(false);
    }
  };

  const handleCancel = () => {
    navigate("/admin/clients/pending");
  };

  return (
    <div className="pricing-wrapper">
      <div className="pricing-header">
        <h2>Configure Client Pricing</h2>
      </div>

      <div className="pricing-client-card">
        <div className="pricing-client-info">
          <div className="pricing-client-item">
            <label>Client Name</label>
            <span>{client?.username || "-"}</span>
          </div>

          <div className="pricing-client-item">
            <label>Company Name</label>
            <span>{client?.companyName || "-"}</span>
          </div>

          <div className="pricing-client-item">
            <label>Email</label>
            <span>{client?.email || "-"}</span>
          </div>
        </div>
      </div>

      <div className="pricing-form-card">
        <h3 className="pricing-form-title">
          Configure Pricing For Verification Checks
        </h3>

        {pricingItems.map((item, index) => (
          <div key={item.checkId} className="pricing-row">
            <div className="pricing-left">
              <label>{item.checkName}</label>
            </div>

            <div className="price-field">
              <div
                className={`price-box ${
                  errors[item.checkId] ? "price-box-error" : ""
                }`}
              >
                <span className="price-symbol">₹</span>

                <input
                  type="number"
                  className="pricing-input"
                  min="0"
                  placeholder="Enter Price"
                  value={item.price}
                  onChange={(e) => handlePrice(index, e.target.value)}
                />
              </div>

              {errors[item.checkId] && (
                <div className="pricing-error">
                  {errors[item.checkId]}
                </div>
              )}
            </div>
          </div>
        ))}

        <div className="pricing-button-group">
          <button
            className="pricing-reset-btn"
            onClick={handleCancel}
            disabled={saving}
          >
            <FaTimes />
            &nbsp;Cancel
          </button>

          <button
            className="pricing-save-btn"
            onClick={handleSaveAndApprove}
            disabled={saving}
          >
            <FaSave />
            &nbsp;
            {saving ? "Saving..." : "Save & Approve"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default PostClientPricing;